import { render, staticRenderFns } from "./dev-info.vue?vue&type=template&id=6dd3894a&"
import script from "./dev-info.vue?vue&type=script&lang=js&"
export * from "./dev-info.vue?vue&type=script&lang=js&"
import style0 from "./dev-info.vue?vue&type=style&index=0&id=6dd3894a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports